import React, { useState, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import CalendarFormation from './CalendarFormation/CalendarFormation'
import CalendarHeader from './CalendarHeader/CalendarHeader'
import CalendarSideBar from './CalendarSideBar/CalendarSideBar'
import data from 'src/data'
import map from 'src/static/svg/map/Ciudades-icex.svg'
import map2026 from 'src/static/svg/map/Ciudades-icex-2026.svg'

import './Calendar.sass'

const Calendar = ({ onView = false }) => {
  const [cityId, setCityId] = useState(-1)
  const [selectedYear, setSelectedYear] = useState('2026')

  const { cities, cities2026 } = data
  const currentCities = selectedYear === '2025' ? cities : cities2026

  const cityData =
    cityId === -1
      ? null
      : currentCities.find(c => c.id === cityId)

  const mapRef = useRef(null)

  const handleCityChange = (id) => {
    setCityId(id)
    if (mapRef && mapRef.current) {
      mapRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const handleYearChange = (year) => {
    setSelectedYear(year)
    setCityId(-1)
  }

  const currentMap = selectedYear === '2025' ? map : map2026

  return (
    <section id="calendar" className={onView ? 'onView' : ''}>
      <h1 className="title">
        <FormattedMessage id="calendar-page.title" />
      </h1>

      <div className="year-buttons">
        {['2025', '2026'].map((year) => (
          <button
            key={year}
            className={year === selectedYear ? 'active' : ''}
            onClick={() => handleYearChange(year)}
          >
            {year}
          </button>
        ))}
      </div>

      <div className="container">
        <CalendarHeader selectedYear={selectedYear} />
        <div className="split">
          <div className="item item-left" ref={mapRef}>
            <CalendarSideBar
              cities={currentCities}
              cityData={cityData}
              setCityId={handleCityChange}
            />
          </div>
          <div className="item item-right">
            {cityId === -1 ? (
              <img src={currentMap} alt={`Mapa ${selectedYear}`} />
            ) : (
              cityData && (
                <img
                  src={`/svg/map/${cityData.mapSrc}`}
                  alt={`Mapa de ${cityData.name}`}
                />
              )
            )}
          </div>
        </div>

        <CalendarFormation
          cities={currentCities}
          setCityId={setCityId}
          mapRef={mapRef}
        />
      </div>
    </section>
  )
}

export default Calendar
